module.exports = __webpack_public_path__ + "img/IX.845cc714.png";